import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import {
  GET_SUPPLIER_USER_SCOPE_PERMISSION,
  UserScopePermissionRes,
} from '../api/user'
import {
  GET_HUISHUIYUN_TOKEN,
  GetHuiShuiYunSsoParams,
  HuiShuiYunSsoResponse,
  HuiShuiYunTokenResponse,
} from '../api/huishuiyun'
import { isResponseCodeSuccess, isResponseSuccess } from '../tools/util'
import { useShallow } from 'zustand/react/shallow'
import { LoadSelectData } from '@/global/fetchData'
import { useOssStore } from './ossSelect'
import { GlobalStorage } from '@/global/storage'
import { GET_FORBID_CHAR } from '@/api/InventoryManagementApi'
import { message } from 'antd'

// 应用全局状态
interface State {
  userInfo: UserScopePermissionRes | null
  getUserInfo: () => Promise<void>
  isGlobalDataLoading: boolean
  setIsGlobalDataLoading: (val: boolean) => void
  hsyTokenRes: HuiShuiYunSsoResponse | undefined
  getHsyToken: (params?: GetHuiShuiYunSsoParams) => Promise<void>
  productForbidChar: string
  getProductForbidChar: () => Promise<string>
}

export const useAppStore = create<State>()(
  devtools((set, get) => ({
    userInfo: null,
    isGlobalDataLoading: false,
    hsyTokenRes: undefined,
    productForbidChar: '',
    async getUserInfo() {
      try {
        const res = await GET_SUPPLIER_USER_SCOPE_PERMISSION()
        if (isResponseCodeSuccess(res.code)) {
          set({
            userInfo: res.data,
          })
          GlobalStorage.setStorageSync('USER_INFO', res.data)
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
      }
    },
    async getHsyToken(params?: GetHuiShuiYunSsoParams) {
      try {
        const res = await GET_HUISHUIYUN_TOKEN(params)
        if (isResponseSuccess(res)) {
          set({
            hsyTokenRes: res.data,
          })
        }
      } catch (error) {
        console.error('获取慧穗云令牌失败:', error)
      }
    },
    async getProductForbidChar() {
      const res = await GET_FORBID_CHAR()
      if (isResponseCodeSuccess(res.code)) {
        set({
          productForbidChar: res.data,
        })
        GlobalStorage.setStorageSync('PRODUCT_FORBID_CHAR', res.data)
        return res.data
      } else {
        message.error(res.msg)
        return ''
      }
    },
    setIsGlobalDataLoading(val) {
      set({
        isGlobalDataLoading: val,
      })
    },
  })),
)

export function useGlobalData() {
  const { getUserInfo, setIsGlobalDataLoading, getProductForbidChar } =
    useAppStore(
      useShallow((state) => ({
        getUserInfo: state.getUserInfo,
        setIsGlobalDataLoading: state.setIsGlobalDataLoading,
        getProductForbidChar: state.getProductForbidChar,
      })),
    )
  const getOssSelect = useOssStore((state) => state.getOssSelect)
  async function loadGlobalData() {
    setIsGlobalDataLoading(true)
    await Promise.all([
      getUserInfo(),
      LoadSelectData(),
      getOssSelect(),
      getProductForbidChar(),
    ])
    setIsGlobalDataLoading(false)
  }
  return {
    loadGlobalData,
  }
}
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import {
  GET_SUPPLIER_USER_SCOPE_PERMISSION,
  UserScopePermissionRes,
} from '../api/user'
import {
  GET_HUISHUIYUN_TOKEN,
  GetHuiShuiYunSsoParams,
  HuiShuiYunSsoResponse,
  HuiShuiYunTokenResponse,
} from '../api/huishuiyun'
import { isResponseCodeSuccess, isResponseSuccess } from '../tools/util'
import { useShallow } from 'zustand/react/shallow'
import { LoadSelectData } from '@/global/fetchData'
import { useOssStore } from './ossSelect'
import { GlobalStorage } from '@/global/storage'
import { GET_FORBID_CHAR } from '@/api/InventoryManagementApi'
import { message } from 'antd'

// 应用全局状态
interface State {
  userInfo: UserScopePermissionRes | null
  getUserInfo: () => Promise<void>
  isGlobalDataLoading: boolean
  setIsGlobalDataLoading: (val: boolean) => void
  hsyTokenRes: HuiShuiYunSsoResponse | undefined
  getHsyToken: (params?: GetHuiShuiYunSsoParams) => Promise<void>
  productForbidChar: string
  getProductForbidChar: () => Promise<string>
}

export const useAppStore = create<State>()(
  devtools((set, get) => ({
    userInfo: null,
    isGlobalDataLoading: false,
    hsyTokenRes: undefined,
    productForbidChar: '',
    async getUserInfo() {
      try {
        const res = await GET_SUPPLIER_USER_SCOPE_PERMISSION()
        if (isResponseCodeSuccess(res.code)) {
          set({
            userInfo: res.data,
          })
          GlobalStorage.setStorageSync('USER_INFO', res.data)
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
      }
    },
    async getHsyToken(params?: GetHuiShuiYunSsoParams) {
      try {
        const res = await GET_HUISHUIYUN_TOKEN(params)
        if (isResponseSuccess(res)) {
          set({
            hsyTokenRes: res.data,
          })
        }
      } catch (error) {
        console.error('获取慧穗云令牌失败:', error)
      }
    },
    async getProductForbidChar() {
      const res = await GET_FORBID_CHAR()
      if (isResponseCodeSuccess(res.code)) {
        set({
          productForbidChar: res.data,
        })
        GlobalStorage.setStorageSync('PRODUCT_FORBID_CHAR', res.data)
        return res.data
      } else {
        message.error(res.msg)
        return ''
      }
    },
    setIsGlobalDataLoading(val) {
      set({
        isGlobalDataLoading: val,
      })
    },
  })),
)

export function useGlobalData() {
  const { getUserInfo, setIsGlobalDataLoading, getProductForbidChar } =
    useAppStore(
      useShallow((state) => ({
        getUserInfo: state.getUserInfo,
        setIsGlobalDataLoading: state.setIsGlobalDataLoading,
        getProductForbidChar: state.getProductForbidChar,
      })),
    )
  const getOssSelect = useOssStore((state) => state.getOssSelect)
  async function loadGlobalData() {
    setIsGlobalDataLoading(true)
    await Promise.all([
      getUserInfo(),
      LoadSelectData(),
      getOssSelect(),
      getProductForbidChar(),
    ])
    setIsGlobalDataLoading(false)
  }
  return {
    loadGlobalData,
  }
}
